import { INT_MAX_SIGNED_32_BIT_VALUE } from '../../../../globals/globals';

export default class IPBoardPartType {
  label?: string;
  ordinal?: number;

  constructor(label: string, ordinal: number) {
    this.label = label;
    this.ordinal = ordinal;
  }
}

export const IP_BOARD_PART_TYPE_CHOICES = {
  IP_70_100: new IPBoardPartType('IP 70 x 100 cm', 0),
  IP_100_140: new IPBoardPartType('IP 100 x 140 cm', 1),
  ADHESIVE_BOARD: new IPBoardPartType('Kleefbord', 2),
  OTHER_DIMENSIONS: new IPBoardPartType(
    'Andere afmetingen',
    INT_MAX_SIGNED_32_BIT_VALUE
  )
};

export const IP_BOARD_PART_TYPE_CHOICES_ARRAY = Object.values(
  IP_BOARD_PART_TYPE_CHOICES
);
